module.exports = __webpack_public_path__ + "img/keen-null.bbef9044.png";